// extracted by mini-css-extract-plugin
module.exports = {"custom-button":"CustomButton_custom-button__3D8ES","customButton":"CustomButton_custom-button__3D8ES"};